import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { ApiPartnerService } from "../../api/api-partner.service";
import { ActivatedRoute } from "@angular/router";
import { AuthenticationService } from "@app/_services/authentication.service";
import swal from "sweetalert/dist/sweetalert.min.js";

@Component({
  selector: "app-resetstbnextsys",
  templateUrl: "./resetstbnextsys.component.html",
  styleUrls: ["./resetstbnextsys.component.css"],
})
export class ResetstbnextsysComponent implements OnInit {
  @ViewChild("closeReset", { static: false })
  closeReset!: ElementRef<HTMLButtonElement>;

  // Rows yang sudah dipetakan dari data List All STB (paired=true, Active)
  packageList: any = [];
  paging: any = {};

  // Item yang dipilih untuk di-reset (dipakai modal konfirmasi)
  selectedItem: any = null;

  msearch!: string;
  page_self: any = [];
  page_next: any = [];
  page_prev: any = [];
  meta: any = [];
  last_index!: number;
  first_index!: number;
  total_count!: number;
  querySearch = false;
  queryParams = "";
  searchQueryParams = "";

  table_load = false;
  currentUser: any;
  isLoading: boolean = false;

  constructor(
    public partnerService: ApiPartnerService,
    private route: ActivatedRoute,
    private Auth: AuthenticationService
  ) {}

  ngOnInit() {
    this.currentUser = this.Auth.currentUserValue;
    this.loadStart();
  }

  loadStart() {
    this.route.queryParams.subscribe((params) => {
      // Data diambil dari liststbpartner (List All STB), filter Active di frontend
      let parts: string[] = [];

      if (params.page) {
        parts.push("page=" + params.page);
      }

      if (params.search != "" && params.search != undefined) {
        this.msearch = params.search;
        this.querySearch = true;
        parts.push("search=" + params.search);
      } else {
        this.querySearch = false;
      }

      const qp = parts.length ? "?" + parts.join("&") : "";
      this.queryParams = qp;
      this.loadResetStb(qp);
    });
  }

  refreshPage() {
    this.ngOnInit();
  }

  // Ambil data dari List All STB, filter Active (customersts === 10), map ke baris tabel
  loadResetStb(params: any) {
    this.table_load = true;
    return this.partnerService
      .GetListpartnernextsysstb(params)
      .subscribe((output: any) => {
        console.log(output);

        const rows = Array.isArray(output.data) ? output.data : [];
        this.packageList = rows
          .filter((stb: any) => stb.customer && stb.customer.customersts === 10)
          .map((stb: any) => this.mapStb(stb));

        this.table_load = false;
        this.setPaging(output);
      });
  }

  // Pemetaan satu item STB -> bentuk baris yang dipakai tabel
  private mapStb(stb: any) {
    const c = stb.customer || {};
    return {
      partnername: stb.partnername || c.partnername || "-",
      customerid: c.id || stb.pairingto || "-",
      macaddress: stb.macaddress || c.stbmacaddress || "-",
      servicestatus: 1, // label hijau (Active)
      servicestatusname: c.customerstatusname || "-",
      servicestartdate: c.activationdate || "-",
      serviceenddate: "", // Active Period = tanggal aktivasi saja
      pairedstbsn: stb.sn || stb.stbsn || "-",
      _raw: stb,
    };
  }

  // Pagination mengikuti pola komponen lain (output.pagex / output.meta)
  private setPaging(output: any) {
    if (output && output.pagex) {
      this.paging = output.pagex;
      this.page_self = output.pagex.self || [];
      this.page_next = output.pagex.next;
      this.page_prev = output.pagex.prev;
      this.meta = output.meta || [];
      this.total_count = this.meta["totalCount"];

      let self = this.page_self["page"] || 1;
      if (self * this.meta["perPage"] < this.meta["totalCount"]) {
        this.last_index = self * this.meta["perPage"];
      } else {
        this.last_index = this.meta["totalCount"];
      }
      this.first_index = (self - 1) * this.meta["perPage"] + 1;
    } else {
      // Fallback bila endpoint tidak mengembalikan pagination
      this.page_self = [];
      this.page_next = null;
      this.page_prev = null;
      this.first_index = this.packageList.length ? 1 : 0;
      this.last_index = this.packageList.length;
      this.total_count = this.packageList.length;
    }
  }

  search() {
    this.querySearch = true;
    this.searchQueryParams = "?paired=true&search=" + this.msearch;
    this.loadResetStb(this.searchQueryParams);
  }

  trackByFn(index: number, item: any) {
    return item && item.pairedstbsn ? item.pairedstbsn : index;
  }

  // Pilih item lalu buka modal konfirmasi (#modalResetStb dibuka via data-target)
  onResetClick(item: any) {
    this.selectedItem = item;
  }

  // Tutup modal konfirmasi secara programatik
  private closeResetModal(): void {
    if (this.closeReset && this.closeReset.nativeElement) {
      this.closeReset.nativeElement.click();
    }
  }

  // Dipanggil dari tombol konfirmasi di dalam modal
  submitReset(item: any) {
    // Guard: abaikan klik kalau tidak ada item ATAU request sedang berjalan
    // (cegah double-click memicu hit API berulang)
    if (!item || this.isLoading) {
      return;
    }
    this.isLoading = true;
    this.closeResetModal();
    const payload = { sn: item.pairedstbsn };

    this.partnerService.PostResetNextsysStb(payload).subscribe(
      (output: any) => {
        this.isLoading = false;
        console.log(output);
        if (output && output.data && output.data.status === true) {
          swal({
            title: "Sukses!",
            text: output.data.message || "STB berhasil di-reset.",
            icon: "success",
            buttons: false,
            timer: 1500,
          }).then(() => {
            this.ngOnInit();
          });
        } else {
          const msg =
            output && output.data && output.data.message
              ? output.data.message
              : "Gagal reset STB.";
          swal({ title: "Gagal!", text: msg, icon: "error" });
        }
      },
      (error: any) => {
        this.isLoading = false;
        console.error("Error reset STB:", error);
        swal({
          title: "Error",
          text: "Terjadi kesalahan saat memanggil API reset STB.",
          icon: "error",
        });
      }
    );
  }
}
